import { HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllCoursesFromEntityUseCaseInterface } from 'domain/usecases';

export class RemoteGetAllCoursesFromEntity
  implements GetAllCoursesFromEntityUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: GetAllCoursesFromEntityUseCaseInterface.Params,
  ): Promise<GetAllCoursesFromEntityUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: generateUrl(this.url, params),
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
